import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';

/**
 * Component for displaying the overall task progress bar and queuing status.
 */
@Component({
  selector: 'app-task-progress-bar',
  imports: [CommonModule, MatProgressBarModule, MatIconModule],
  templateUrl: './task-progress-bar.component.html',
  styleUrls: ['./task-progress-bar.component.scss'],
})
export class TaskProgressBarComponent {
  @Input() overallProgress: number = 0;
  @Input() isRunning: boolean = false;
  @Input() overallMessage: string = '';
  @Input() queuingElapsedTime: string | null = null;
  @Input() hasStepHistory: boolean = false;
  @Input() startTime: Date | null = null;
  @Input() endTime: Date | null = null;
  @Input() elapsedTime: string = '';
  @Input() isCompleted: boolean = false;
  @Input() isFailed: boolean = false;
  @Input() isCancelled: boolean = false;

  /**
   * Determines if tasks are currently queuing.
   * Don't show queuing card if step history is available (to avoid redundancy with step 0).
   */
  isQueuing(): boolean {
    return this.isRunning && this.overallProgress === 0 && !this.hasStepHistory;
  }

  /**
   * Gets the progress value to display.
   * Now that we have proper SERVER_WARMUP step tracking, use the actual progress.
   */
  getAdjustedProgress(): number {
    return this.overallProgress;
  }
}
